import React, { useState, useEffect } from "react";
import axios from "axios";

const Services = () => {
  const [service, setService] = useState([]);

  useEffect(() => {
    getAllServices();
  }, []);

  const getAllServices = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}service`
      );
      setService(response.data.service);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <section
      id="services"
      className="pt-24 pb-24 md:pt-16 bg-slate-100 md:mt-10"
    >
      <div className="container mx-auto px-6 md:px-20">
        <div
          className="w-full text-slate-800 md:mx-10"
          data-aos="fade-right"
          data-aos-duration="800"
        >
          <h3 className="font-poppins text-3xl md:text-4xl font-base  border-l-4 border-secondary pl-4">
            Alasan Mengapa Harus{" "}
            <span className="text-secondary">
              Memilih <br /> Kami
            </span>
            ?
          </h3>
          <p className="font-poppins font-light text-slate-500 text-sm mt-4">
            Berbagai macam layanan yang kami miliki untuk anda
          </p>
        </div>
        <div className="mx-4 mt-8 md:px-8 flex flex-wrap gap-4  justify-center">
          {service.map((svc) => (
            <div
              className="w-[47%] md:w-[20%] md:mx-4"
              data-aos="flip-left"
              data-aos-duration="800"
              key={svc.id}
            >
              <div className="h-[180px] md:h-[225px] py-4 px-4 text-center shadow-sm rounded-2xl bg-third overflow-hidden flex justify-center items-center flex-col">
                <img src={svc.url} className="w-10 h-10 mx-auto" />
                <p className="w-full text-base text-center mt-4 text-white font-poppins font-normal">
                  {svc.name}
                </p>
                <p className="md:text-sm font-light text-[9px] text-slate-50">
                  {svc.caption}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
